import PropTypes from "prop-types";
import { forwardRef } from "react";

import styled from "styled-components/macro";

const Video = forwardRef(({ url }, forwardedRef) => {
  return (
    <VideoWrapper className="video" ref={forwardedRef}>
      <VideoFrame
        src={url}
        title="YouTube video player"
        allow="picture-in-picture;"
        allowFullScreen
      />
    </VideoWrapper>
  );
});

Video.propTypes = {
  url: PropTypes.string,
};

export default Video;

const VideoWrapper = styled.div`
  background: #000;
  flex-shrink: 0;
  width: calc(100%);
  max-width: 600px;
  aspect-ratio: 16/9;
  border-radius: 6px;
  box-shadow: rgba(0, 0, 0, 0.6) 1px 1px 12px;
  grid-area: video;
  align-self: center;
  order: 2;
`;

const VideoFrame = styled.iframe`
  border-radius: 6px;
  overflow: hidden;

  width: 100%;
  height: 100%;
  box-sizing: border-box;
  border: none;
  display: block;
`;
